import { render, staticRenderFns } from "./CategorySliders.vue?vue&type=template&id=7c41e6c6&scoped=true&"
import script from "./CategorySliders.vue?vue&type=script&lang=js&"
export * from "./CategorySliders.vue?vue&type=script&lang=js&"
import style0 from "./CategorySliders.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CategorySliders.vue?vue&type=style&index=1&id=7c41e6c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c41e6c6",
  null
  
)

export default component.exports